import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestProductRegister from './request/requestProductRegister'
import requestEditRegister from './request/requestEditRegister'
import requestMakerEdit from './request/requestMakerEdit'
import requestMakerRegister from './request/requestMakerRegister'
import requestProductStockList from './request/requestProductStockList'
import { i18n } from '@/main.js'

const Actions = {
  // IT04 商品在庫一覧取得
  getProductAndStockListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    // 仕入先別の商品在庫一覧モックを取得する
    let mockFileName = 'productStock'
    if (params && params.supplierId) {
      mockFileName = params.supplierId
    }

    const req = requestProductStockList.request.createRequest(params)

    return await axios
      // .get(
      //   apiMock.PRODUCT_AND_STOCK_LIST.replace('{productStock}', mockFileName)
      // )
      .get(api.PRODUCT_AND_STOCK_LIST, { params: req })
      .then((response) => {
        const path = mutationsTypes.PRODUCT_SET_PRODUCT_AND_STOCK_LIST

        commit(path, response.data.data)
        const getData = getters.getProductAndStockListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // IT01 商品一覧取得
  getProductListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.PRODUCT_LIST)
      .get(api.PRODUCT_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.PRODUCT_SET_PRODUCT_LIST
        const data = response.data.data
        data.productList.forEach((p) => {
          p.isEnabledPenguin = !!p.integrationProductId
        })
        commit(path, data)
        const getData = getters.getProductListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // IT02 商品登録
  registerProduct: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestProductRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.PRODUCT_REGISTER_EDIT)
      .post(api.PRODUCT_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // IT03 商品編集
  editProduct: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    { productId, params }
  ) => {
    await getCsrfToken()
    const req = requestEditRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.PRODUCT_REGISTER_EDIT)
      .patch(`${api.PRODUCT_REGISTER_EDIT}/${productId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // MK01 メーカー一覧取得
  getMakerListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      // .get(apiMock.MAKER_LIST)
      .get(api.MAKER_LIST)
      .then((response) => {
        const path = mutationsTypes.PRODUCT_SET_MAKER_LIST

        commit(path, response.data.data)

        const getData = getters.getMakerListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // MK02 メーカー登録
  registerMaker: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestMakerRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.MAKER_REGISTER_EDIT)
      .post(api.MAKER_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // MK03 メーカー編集
  editMaker: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    { makerId, params }
  ) => {
    await getCsrfToken()
    const req = requestMakerEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.MAKER_REGISTER_EDIT)
      .patch(`${api.MAKER_REGISTER_EDIT}/${makerId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // IT06 商品CSVアップロード
  fileUpload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    file
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.FILE_UPLOAD)
      .post(api.PRODUCT_CSV_UPLOAD, file)
      .then((response) => {
        const ret = commonUtil.afterApiSuccessProcess(
          response,
          response.data.data
        )
        return ret
      })
      .catch((error) => {
        if (error.response.data.data && error.response.data.data.errorList) {
          const errors = []
          error.response.data.data.errorList.forEach((ele) => {
            for (const index in ele.errors) {
              ele.errors[index].flat().forEach((error) => {
                const errorMsg =
                  i18n.locale === 'cn'
                    ? `第${ele.lineNumber}行 ${error}`
                    : `${ele.lineNumber}行目 ${error}`
                errors.push(errorMsg)
              })
            }
          })

          alert(`${errors.join('\n')}`)
          return false
        }
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
